import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Header from "../header";
import Footer from "../footer.js";
import { Route, Switch } from "react-router-dom";
import { getFavicon, getPlatform } from "../../../helpers/layout";
import { dplusRoutes } from "../../../routes";
import * as paths from "../../../constants/paths";
import { DiscoveryPlus, en } from "../../../constants/label";
import { setBrand, setPlatform } from "../../../store/actions/form";
import { Redirect } from "react-router";

const Main = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const favicon = getFavicon();
        favicon.href = "/faviconDplus.ico";

        dispatch(setBrand(DiscoveryPlus));
        dispatch(setPlatform(getPlatform(window.location.href)));
        // eslint-disable-next-line
    }, []);

    return (
        <div>
            <Header />
            <Switch>
                {dplusRoutes(paths.subDomainFrance).map((route, key) =>
                    <Route
                        exact
                        path={route.paths}
                        component={route.component}
                        key={key}
                    />
                )}
                <Route
                    path="*"
                    render={({ location }) => {
                        const segments = location.pathname.split("/").filter(Boolean);
                        const last = segments[segments.length - 1];

                        const allowed = [en];
                        if (allowed.includes(last)) {
                            return null;
                        }
                        if (segments.length > 1) {
                            const cleanPath = "/" + segments.slice(0, -1).join("/");
                            return <Redirect to={cleanPath} />;
                        }

                        return null;
                    }}
                />
                <Redirect to={paths.dplus_website_form(paths.subDomainFrance)} />
            </Switch>
            <Footer />
        </div>
    );
};

export default Main;
